import {useCallback,useState} from 'react';
const key=(id:string)=>`tableread.editor.awaiting-play.${id}`;
const restored=(id:string)=>{try{return localStorage.getItem(key(id))==='true';}catch{return true;}};
/** Persist intent only, never screenplay text. Storage failure defaults to no automatic generation. */
export function usePlayToConvert(screenplayId:string){
  const [state,setState]=useState(()=>({id:screenplayId,pending:restored(screenplayId)}));
  const pending=state.id===screenplayId?state.pending:restored(screenplayId);
  const update=useCallback((value:boolean)=>{
    try{if(value)localStorage.setItem(key(screenplayId),'true');else localStorage.removeItem(key(screenplayId));}catch{/* Current session still works. */}
    setState({id:screenplayId,pending:value});
  },[screenplayId]);
  return {pending,defer:()=>update(true),authorize:()=>update(false)};
}
